import React, {useState} from "react";

import './Team.delete.dialog.scss';
import Modal from "react-modal";
import {useMutation} from "@apollo/client";
import gqlSchemaLibrary from "../../services/graphql.schemas";
import {useTranslation} from "react-i18next";
import {ModalLog} from "../../services/interactions/elements/modal";
import AuditTrail, {PAGES} from "../../services/interactions/audit.trail";

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        border: "none",
        padding: "0px",
        boxShadow: "0 3px 8px 0 rgba(0, 0, 0, 0.38)",
    }
};
Modal.setAppElement('#root');

const _Modal = ModalLog(Modal);

function ItemDeleteDialog({type, program, item, items, openModal, closeModal}) {
    const {t} = useTranslation(['common','teams']);
    const [__submitting, __setSubmitting] = useState(false);

    const closeModalEmpty = () => {
        AuditTrail.sendLog(PAGES.PROGRAM_USERS, {tag: 'button', event: 'closeModal', action: 'button close modal', program_id: program._id});
        closeModal();
    }

    const [deleteUsers] = useMutation(gqlSchemaLibrary.programs.mutation.editProgramUsers, {
        onCompleted: ({ data }) => {
            __setSubmitting(false);
            closeModal(item? [item] : items);
        },
        onError: (e) => {
            AuditTrail.sendLog(PAGES.PROGRAM_USERS, {tag: 'button', event: 'OnSubmit', action: 'modal button error delete', program_id: program._id, type: type, ids: type === 'user'? (item? [item._id] : items.map((t) => t._id)) : (item? [item._id] : items.map((t) => t._id))});
            console.error('Rename Team Error: ', e);
            __setSubmitting(false);
        }
    });

    const [deleteTeams] = useMutation(gqlSchemaLibrary.programs.mutation.editProgramTeams, {
        onCompleted: ({ data }) => {
            __setSubmitting(false);
            closeModal(item? [item] : items);
        },
        onError: (e) => {
            AuditTrail.sendLog(PAGES.PROGRAM_USERS, {tag: 'button', event: 'OnSubmit', action: 'modal button error delete', program_id: program._id, type: type, ids: type === 'user'? (item? [item._id] : items.map((t) => t._id)) : (item? [item._id] : items.map((t) => t._id))});
            console.error('Rename Team Error: ', e);
            __setSubmitting(false);
        }
    });

    const onDelete = () => {
        if (__submitting) {
            return;
        }

        AuditTrail.sendLog(PAGES.PROGRAM_USERS, {tag: 'button', event: 'onClick', action: 'modal deletes items', program_id: program._id, type: type, ids: type === 'user'? (item? [item._id] : items.map((t) => t._id)) : (item? [item._id] : items.map((t) => t._id))});
        __setSubmitting(true);
        type === 'user'? deleteUsers({
            variables: {
                programId: program._id,
                usersIds: item? [item._id] : items.map((t) => t._id)
            }
        }) : deleteTeams({
            variables: {
                programId: program._id,
                teamsIds: item? [item._id] : items.map((t) => t._id)
            }
        });
    }

    const getName = () => {
        if (item) {
            return type === 'user'? (
                <>
                    Remove user <b>{item.user.bio.lastname}, {item.user.bio.firstname}</b> from:
                </>
            ) : (
                <>
                    Remove team <b>{item.name}</b> from:
                </>
            );
        }
        return type === 'user'? (
            <>
                Remove <b>{items.length}</b> user{items.length===1? '' : 's' } from:
            </>
        ) : (
            <>
                Remove <b>{items.length}</b> team{items.length===1? '' : 's' } from:
            </>
        );
    }

    const getContent = () => {
        if (item) {
            return type === 'user'? (
                <>
                    User <b>{item.user.bio.lastname}, {item.user.bio.firstname}</b> will be removed from the program <b>{program.name}</b>.<br/>
                    Any activities associated with this user will be eliminated.
                </>
            ): (
                <>
                    Team <b>{item.name}</b> will be removed from the program <b>{program.name}</b>.<br/>
                    Any activities associated with this team will be eliminated.
                </>
            );
        }
        return type === 'user'? (
            <>
                Any activities associated with these users will be removed.
            </>
        ) : (
            <>
                Any activities associated with these teams will be removed.
            </>
        );
    }

    const getButtonConfirmLabel = () => {
        const s = item || items.length === 1? '' : 's';
        return (type === 'user'? t('teams:remove-user') : t('teams:remove-team'))+s;
    }

    const eventParams = {
        type: type,
        ids: type === 'user'? (item? [item._id] : items.map((t) => t._id)) : (item? [item._id] : items.map((t) => t._id))
    }

    return (
        <_Modal
            isOpen={!!openModal}
            style={customStyles}
            onRequestClose={closeModalEmpty}
            label="ItemsDeleteDialog"
            event={PAGES.PROGRAM_USERS}
            eventParams={eventParams}>
            <div id="ItemsDeleteDialog">
                <div className="__MembersTitle">
                    <i className="material-icons" onClick={closeModalEmpty}>arrow_back_ios</i>
                    <h3>{getName()}</h3>
                    <p>{program? program.name : ''}</p>
                </div>
                <div className="__Container">
                    <p>
                        {getContent()}
                    </p>
                    <div className="containerButtons">
                        <button className="primary gray" onClick={closeModalEmpty}>
                            {t('cancel')}
                        </button>
                        <button disabled={false} className="primary blue" onClick={onDelete}>
                            {getButtonConfirmLabel()}
                        </button>
                    </div>
                </div>
            </div>
        </_Modal>
    );
}

export default ItemDeleteDialog;
